import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    seconds: { type: Number, default: 60 },
    redirectUrl: { type: String, default: "" }
  }

  static targets = ["display"]

  connect() {
    this.timeRemaining = this.secondsValue
    this.updateDisplay()
    this.startTimer()
  }

  disconnect() {
    this.stopTimer()
  }

  startTimer() {
    this.timer = setInterval(() => {
      this.timeRemaining -= 1

      if (this.timeRemaining <= 0) {
        this.stopTimer()
        this.redirect()
      } else {
        this.updateDisplay()
      }
    }, 1000)
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  updateDisplay() {
    if (this.hasDisplayTarget) {
      this.displayTarget.textContent = this.timeRemaining
    }
  }

  redirect() {
    if (this.redirectUrlValue) {
      window.location = this.redirectUrlValue
    }
  }
}
